import React from 'react';
import { LandingPage as LandingPageComponent } from 'components/landing-page/LandingPage';

export const LandingPage: React.FC = () => {
    return <LandingPageComponent />;
};
